<app-modal-header class="border-b-2 border-modules-eclass-500">
  <div class="flex w-full items-center gap-2">
    <div class="flex">
      <svg-icon class="w-16 lg:w-24" src="assets/images/logos/logo-eclass.svg" alt="Materiais Didaticos"></svg-icon>
    </div>
    <hr app-modal-divider />
    <h1 class="text-lg" translate>suporte.titulo-modal</h1>
  </div>
</app-modal-header>
<div app-modal-content class="h-auto max-h-[70vh] w-[60vw] overflow-y-auto !rounded-none p-5 pt-8">
  <div [formGroup]="form" class="mb-4 flex w-full flex-col gap-4">
    <div class="flex w-full gap-4">
      <div class="flex w-full flex-col">
        <div class="flex">
          <label app-label translate> suporte.nome </label>
        </div>
        <input
          app-input
          formControlName="nome"
          [ngClass]="{
            'border-red-500': form.controls.nome.invalid && form.controls.nome.touched,
            'border-gray-200': !form.controls.nome.invalid || !form.controls.nome.touched
          }"
          [placeholder]="'suporte.insira-nome' | translate"
        />
      </div>
      <div class="flex w-full flex-col">
        <div class="flex">
          <label app-label translate> suporte.numero-telefone </label>
          <svg-icon
            app-tooltip
            [tooltip]="'suporte.dados-devolutiva' | translate"
            class="ml-3 flex h-5 w-5 cursor-help"
            src="assets/icons/icon-help.svg"
          ></svg-icon>
        </div>
        <input
          app-input
          formControlName="telefone"
          [ngClass]="{
            'border-red-500': form.controls.telefone.invalid && form.controls.telefone.touched,
            'border-gray-200': !form.controls.telefone.invalid || !form.controls.telefone.touched
          }"
          placeholder="(00) 00000-0000"
        />
      </div>
      <div class="flex w-full flex-col">
        <div class="flex">
          <label app-label translate> suporte.email </label>
          <svg-icon
            app-tooltip
            [tooltip]="'suporte.tooltip-email' | translate"
            class="ml-3 flex h-5 w-5 cursor-help"
            src="assets/icons/icon-help.svg"
          ></svg-icon>
        </div>
        <input
          app-input
          formControlName="email"
          [ngClass]="{
            'border-red-500': form.controls.email.invalid && form.controls.email.touched,
            'border-gray-200': !form.controls.email.invalid || !form.controls.email.touched
          }"
          [placeholder]="'suporte.insira-email' | translate"
        />
      </div>
    </div>
    <div class="flex w-full gap-4">
      <div class="flex w-full flex-col">
        <label app-label translate> suporte.tipo-feedback.titulo </label>
        <ng-select
          app-select
          formControlName="tipo"
          [items]="optionsTypes"
          bindValue="value"
          [searchable]="false"
          [clearable]="false"
          [placeholder]="'suporte.tipo-feedback.selecione' | translate"
        >
          <ng-template ng-label-tmp ng-option-tmp let-item="item">
            <div class="flex items-center" [ngClass]="item.class">
              <span class="mr-2 font-semibold">{{ item.label }}</span>
              <div [ngSwitch]="item.value" class="!h-5 !w-5">
                <ng-container>
                  <svg-icon [src]="item.icon"></svg-icon>
                </ng-container>
              </div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <div class="flex w-full flex-col">
        <label app-label translate> suporte.produto </label>
        <ng-select
          app-select
          formControlName="produto"
          [items]="optionsProdutos$ | async"
          bindLabel="label"
          bindValue="key"
          [searchable]="false"
          [clearable]="false"
        >
          <ng-template ng-label-tmp ng-option-tmp let-item="item">
            <div [attr.style]="'color:' + item.color" class="flex items-center !font-light">
              <span class="mr-2 font-bold">{{ item.label }}</span>
              <div [ngSwitch]="item.value" class="!h-5 !w-5">
                <ng-container>
                  <svg-icon [src]="item.icon"></svg-icon>
                </ng-container>
              </div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
    <ng-container
      *ngIf="!!form.get('formulario').value"
      formGroupName="formulario"
      [ngSwitch]="form.get('produto').value"
    >
      <div class="flex w-full flex-col gap-4" *ngSwitchCase="'assessments-manager'">
        <div class="flex w-full gap-4">
          <div class="flex w-4/12 flex-col">
            <div class="flex">
              <label app-label translate> suporte.codigo </label>
            </div>
            <input
              app-input
              formControlName="codigo"
              class="border-gray-200"
              [placeholder]="'suporte.insira-codigo' | translate"
            />
          </div>
          <div class="flex w-8/12 flex-col">
            <div class="flex">
              <label app-label translate> suporte.autor </label>
            </div>
            <input
              app-input
              formControlName="autor"
              class="border-gray-200"
              [placeholder]="'suporte.insira-autor' | translate"
            />
          </div>
        </div>
        <div class="flex w-full gap-4">
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.unidade </label>
            </div>
            <input
              app-input
              formControlName="unidade"
              class="border-gray-200"
              [placeholder]="'suporte.insira-unidade' | translate"
            />
          </div>
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.turma-aluno </label>
            </div>
            <input
              app-input
              formControlName="turma_aluno"
              class="border-gray-200"
              [placeholder]="'suporte.insira-turma-aluno' | translate"
            />
          </div>
        </div>
      </div>
      <div class="flex w-full flex-col gap-4" *ngSwitchCase="'assessments-manager-question'">
        <div class="flex w-full gap-4">
          <div class="flex w-full flex-col">
            <label>
              <span class="text-sm font-medium"> {{ 'suporte.codigo-questao' | translate }}: </span>
              <span app-clipboard [clipboard]="data.question.code | uppercase" class="ml-1 font-semibold uppercase">
                #{{ data.question.code }}
              </span>
            </label>
          </div>
        </div>
      </div>
      <div class="flex w-full flex-col gap-4" *ngSwitchCase="'eclass'">
        <div class="flex w-full gap-4">
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.titulo </label>
            </div>
            <input
              app-input
              formControlName="titulo"
              class="border-gray-200"
              [placeholder]="'suporte.insira-titulo-eclass' | translate"
            />
          </div>
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.unidade </label>
            </div>
            <input
              app-input
              formControlName="unidade"
              class="border-gray-200"
              [placeholder]="'suporte.insira-unidade' | translate"
            />
          </div>
        </div>
        <div class="flex w-full gap-4">
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.autor </label>
            </div>
            <input
              app-input
              formControlName="autor"
              class="border-gray-200"
              [placeholder]="'suporte.insira-autor' | translate"
            />
          </div>
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.turma-aluno </label>
            </div>
            <input
              app-input
              formControlName="turma_aluno"
              class="border-gray-200"
              [placeholder]="'suporte.insira-turma-aluno' | translate"
            />
          </div>
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.disciplina </label>
            </div>
            <input
              app-input
              formControlName="disciplina"
              class="border-gray-200"
              [placeholder]="'suporte.insira-disciplina' | translate"
            />
          </div>
        </div>
      </div>
      <div class="flex w-full flex-col gap-4" *ngSwitchCase="'learning-trails'">
        <div class="flex w-full gap-4">
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.titulo </label>
            </div>
            <input
              app-input
              formControlName="titulo"
              class="border-gray-200"
              [placeholder]="'suporte.insira-titulo-trilhas' | translate"
            />
          </div>
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.unidade </label>
            </div>
            <input
              app-input
              formControlName="unidade"
              class="border-gray-200"
              [placeholder]="'suporte.insira-unidade' | translate"
            />
          </div>
        </div>
      </div>
      <div class="flex w-full flex-col gap-4" *ngSwitchCase="'materials'">
        <div class="flex w-full gap-4">
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.serie </label>
            </div>
            <input
              app-input
              formControlName="serie"
              class="border-gray-200"
              [placeholder]="'suporte.insira-serie' | translate"
            />
          </div>
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.disciplina </label>
            </div>
            <input
              app-input
              formControlName="disciplina"
              class="border-gray-200"
              [placeholder]="'suporte.insira-disciplina' | translate"
            />
          </div>
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.unidade </label>
            </div>
            <input
              app-input
              formControlName="unidade"
              class="border-gray-200"
              [placeholder]="'suporte.insira-unidade' | translate"
            />
          </div>
        </div>
      </div>
      <div class="flex w-full flex-col gap-4" *ngSwitchCase="'academic'">
        <div class="flex w-full gap-4">
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.unidade </label>
            </div>
            <input
              app-input
              formControlName="unidade"
              class="border-gray-200"
              [placeholder]="'suporte.insira-unidade' | translate"
            />
          </div>
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.turma-aluno </label>
            </div>
            <input
              app-input
              formControlName="turma_aluno"
              class="border-gray-200"
              [placeholder]="'suporte.insira-turma-aluno' | translate"
            />
          </div>
        </div>
      </div>
      <div class="flex w-full flex-col gap-4" *ngSwitchCase="'others'">
        <div class="flex w-full gap-4">
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.produto </label>
            </div>
            <input
              app-input
              formControlName="produto"
              class="border-gray-200"
              [placeholder]="'suporte.insira-produto' | translate"
            />
          </div>
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.unidade </label>
            </div>
            <input
              app-input
              formControlName="unidade"
              class="border-gray-200"
              [placeholder]="'suporte.insira-unidade' | translate"
            />
          </div>
          <div class="flex w-full flex-col">
            <div class="flex">
              <label app-label translate> suporte.turma-aluno </label>
            </div>
            <input
              app-input
              formControlName="turma_aluno"
              class="border-gray-200"
              [placeholder]="'suporte.insira-turma-aluno' | translate"
            />
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <app-form-field class="w-full">
    <label app-label translate> suporte.comentario </label>
    <app-text-editor
      [formControl]="form.controls.feedback"
      [url]="urlUploadCkEditorImage"
      [toolbar]="toolbar"
      [ngClass]="{
        'border-red-500': form.controls.feedback.invalid && form.controls.feedback.touched,
        'border-gray-200': !form.controls.feedback.invalid || !form.controls.feedback.touched
      }"
      class="block"
    ></app-text-editor>
  </app-form-field>

  <div class="flex items-center justify-end gap-2">
    <svg-icon src="assets/icons/icon-alert-fill-fine.svg" class="w-6 text-base-status-warning-600"></svg-icon>
    <span class="text-base text-base-status-warning-700" translate> suporte.aviso </span>
  </div>
</div>

<div class="flex w-full justify-end rounded-b-3xl border-t bg-white px-5 py-4 shadow-up md:bottom-0">
  <div class="flex justify-end">
    <button
      (click)="onSend()"
      app-flat-button
      class="flex w-full items-center justify-end bg-theme-500 !px-6 !py-2 uppercase text-theme-contrast text-white duration-300"
      type="button"
      [disabled]="submitted$ | async"
    >
      <ng-container *ngIf="submitted$ | async; else saveTemplate">
        <app-skeleton class="h-5 w-5" baseStyle="bg-theme-500" [showLabel]="false"></app-skeleton>
      </ng-container>
      <ng-template #saveTemplate>
        <span translate>eclass.enviar</span>
      </ng-template>
    </button>
  </div>
</div>
